export default __webpack_public_path__ + "static/media/good_job.0574be87.mp3";